import service from '@/store/services/settings/activity-shifts-service';

const state = {
    list: {},
    activityShift: {},
    meta: {},
    url:null
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, activityShift) => {
        state.activityShift = activityShift;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_URL: (state, url) => {
        state.url = url;
    }
};

const actions = {
    list ({ commit, dispatch }, params) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(activityShift => {
                commit('SET_RESOURCE', activityShift);
            });
    },

    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(activityShift => {
                commit('SET_RESOURCE', activityShift);
            });
    },

    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((activityShift) => {
                commit('SET_RESOURCE', activityShift);
            });
    },

    addShift ({ commit, dispatch }, params) {
        return service.addShift(params)
            .then((activityShift) => {
                commit('SET_RESOURCE', activityShift);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((activityShift) => {
                commit('SET_RESOURCE', activityShift);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};
const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    activityShift: state => state.activityShift,
    dropdown: (state) => {
        return state.list.map(activityShift => ({
            id: activityShift.id,
            name: activityShift.request_type
        }));
    },
    url: state => state.url,
};

const activityShifts = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default activityShifts;
